/* eslint-disable max-len */
import React from 'react';
import { useSelector } from 'react-redux';
import styled, { withTheme } from 'styled-components';
import { getColor } from 'utils';

const InfoSVG = styled('svg')`
  color: ${props => props.color || getColor(props, 'accent')};
`;

const InfoOutlined = withTheme(props => {
  const { theme, width, height, color } = props;
  const appStore = useSelector(state => state.app);
  const selectedTheme = appStore.theme;

  return (
    <InfoSVG
      theme={theme}
      $selectedTheme={selectedTheme}
      color={color}
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'
      role='img'
      width={width || 24}
      height={height || 24}
      preserveAspectRatio='xMidYMid meet'
      viewBox='0 0 24 24'
    >
      <path fill='currentColor' fillRule='evenodd' d='M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11s11-4.925 11-11S18.075 1 12 1Zm-.5 5a1 1 0 1 0 0 2h.5a1 1 0 1 0 0-2h-.5ZM10 10a1 1 0 1 0 0 2h1v3h-1a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2h-1v-4a1 1 0 0 0-1-1h-2Z' clipRule='evenodd' />
    </InfoSVG>
  );
});

export { InfoOutlined };